import { render, staticRenderFns } from "./MainPageCard.vue?vue&type=template&id=7e10490e&scoped=true&"
import script from "./MainPageCard.vue?vue&type=script&lang=js&"
export * from "./MainPageCard.vue?vue&type=script&lang=js&"
import style0 from "./MainPageCard.vue?vue&type=style&index=0&id=7e10490e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e10490e",
  null
  
)

export default component.exports